import {getDate, getMinutes, isEqual, setDate, setHours, setMinutes, setSeconds} from 'date-fns';

const QUARTER_HOUR = 15;
const START_OF_DAY_HOUR = 0;
const END_OF_DAY_HOUR = 23;
const START_OF_MINUTE = 0;
const LAST_MINUTE = 59;
const START_OF_SECOND = 0;
const LAST_SECOND = 59;
const MINUTE_INCREMENT = 1;

export const computeLimitStartTime = (time: Date) => {
  return setHours(setMinutes(setSeconds(new Date(time), START_OF_SECOND), START_OF_MINUTE), START_OF_DAY_HOUR);
};

export const computeLimitEndTime = (time: Date) => {
  return setHours(setMinutes(setSeconds(time, LAST_SECOND), LAST_MINUTE), END_OF_DAY_HOUR);
};

export const computeEndTimeWithOffset = (startTime: Date) => {
  const limitEndTime = computeLimitEndTime(new Date(startTime));

  const endDate = new Date(startTime);
  endDate.setMinutes(endDate.getMinutes() + QUARTER_HOUR);

  if (endDate > limitEndTime) return limitEndTime;

  return endDate;
};

export const calculateEndTime = (startTime: Date, endTime: Date) => {
  let modifiedEndTime = endTime;
  const limitEndTime = computeLimitEndTime(new Date(startTime));

  if (isEqual(startTime, modifiedEndTime)) {
    modifiedEndTime = computeEndTimeWithOffset(startTime);
  }

  if (modifiedEndTime > limitEndTime) {
    modifiedEndTime = limitEndTime;
  }
  const minutes = getMinutes(modifiedEndTime);

  if (modifiedEndTime < limitEndTime && minutes % QUARTER_HOUR !== 0) {
    modifiedEndTime = setMinutes(modifiedEndTime, getMinutes(modifiedEndTime) + MINUTE_INCREMENT);
  }
  return modifiedEndTime;
};

export const getStartTime = (baseTime: Date, selectedDate: Date) => {
  return setDate(baseTime, getDate(selectedDate));
};
